module.exports = __webpack_public_path__ + "static/img/recognition1.8dd13c9e.png";